import { render, staticRenderFns } from "./_photoId.vue?vue&type=template&id=f8558c72&"
import script from "./_photoId.vue?vue&type=script&lang=ts&"
export * from "./_photoId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports